import React, { useEffect, useRef, useState } from 'react';
import update from 'immutability-helper';

import Appearance from 'styles/Appearance.js';
import { DataVault, getNodeIcon } from 'managers/DataVault.js';
import Layer, { LayerItem } from 'structure/Layer.js';
import Request from 'files/Request.js';
import Views from 'views/Main.js';

const DataVaultItemsPickerField = ({ onChange, onFocus, utils, values }) => {

    const [loading, setLoading] = useState(false);
    const [map, setMap] = useState([]);
    const [selections, setSelections] = useState(values || []);

    const onDataVaultEntryClick = entry => {

    }

    const onFieldClick = evt => {

        // notify onFocus subscriber if one has been provided
        if(typeof (onFocus) === 'function') {
            onFocus(evt);
        }

        // open picker layer for data vault
        utils.layer.open({
            Component: DataVaultItemsPickerLayer.bind(this, {
                onChange: results => {

                    // update internal state for selected values
                    setSelections(results);

                    // notify subscribers of data change
                    if (typeof (onChange) === 'function') {
                        onChange(results);
                    }
                },
                selections: selections
            }),
            id: 'data_vault_items_picker_layer'
        });
    }

    const onRemoveItemClick = (index, evt) => {
        evt.stopPropagation();
        let next = update(selections, { $splice: [[index, 1]] });
        setSelections(next);
        if (typeof (onChange) === 'function') {
            onChange(next);
        }
    }

    const fetchVaultItems = async () => {
        try {

            setLoading(true);
            let { map } = await Request.get(utils, '/data_vault/', {
                type: 'items'
            });

            setLoading(false);
            setMap(map);

        } catch (e) {
            setLoading(false);
            utils.alert.error({
                error: e,
                message: `There was an issue retrieving your data vault items. ${e.message || 'An unknown error occurred'}`,
                origin: 'data_vault_items_picker_field.fetch_vault_items'
            });
        }
    }

    useEffect(() => {
        fetchVaultItems();
    }, []);

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%'
        }}>
            <div
                className={`custom-file ${window.theme}`}
                style={{
                    flexGrow: 1,
                    overflow: 'hidden'
                }}>
                <label
                    className={`custom-file-label ${window.theme} cursor-pointer`}
                    onClick={onFieldClick}
                    style={{
                        color: Appearance.colors.subText(),
                        fontSize: 12,
                        fontWeight: 500
                    }}>{'Click to browse Data Vault...'}</label>
            </div>
            {selections.length > 0 && (
                <div style={{
                    ...Appearance.styles.unstyledPanel(),
                    marginTop: 8
                }}>
                    {selections.map((selection, index) => {
                        let item = map.find(i => i.id === selection);
                        return item && (
                            <div key={index}>
                                {Views.row({
                                    bottomBorder: index !== selections.length - 1,
                                    hideOnClickArrow: true,
                                    label: item.text,
                                    onClick: onDataVaultEntryClick.bind(this, index),
                                    prepend: (
                                        <img
                                        src={getNodeIcon(item)}
                                        style={{
                                            height: 20,
                                            marginRight: 8,
                                            objectFit: 'contain',
                                            width: 20
                                        }} />
                                    ),
                                    value: (
                                        <img
                                        className={'text-button'}
                                        onClick={onRemoveItemClick.bind(this, index)}
                                        src={'images/delete-red-icon.png'}
                                        style={{
                                            height: 20,
                                            marginLeft: 8,
                                            objectFit: 'contain',
                                            width: 20
                                        }} />
                                    )
                                })}
                            </div>
                        )
                    })}
                </div>
            )}
        </div>
    )
}

const DataVaultItemsPickerLayer = ({ onChange, selections }, { index, options, utils }) => {

    const layerID = 'data_vault_items_picker_layer';
    const dataVaultRef = useRef(null);

    const [items, setItems] = useState(selections || []);
    const [layerState, setLayerState] = useState(null);

    const onSubmitClick = () => {

        // close layer and notify subscribers of data change
        setLayerState('close');
        if (typeof (onChange) === 'function') {
            onChange(items);
        }
    }

    const getButtons = () => {
        return [{
            color: 'dark',
            id: 'close',
            onClick: setLayerState.bind(this, 'close'),
            text: 'Close'
        }, {
            color: 'primary',
            id: 'done',
            onClick: onSubmitClick,
            text: 'Done'
        }];
    }

    return (
        <Layer
        buttons={getButtons()}
        id={layerID}
        index={index}
        options={{
            ...options,
            layerState: layerState,
            sizing: 'large'
        }}
        utils={utils}>
            <LayerItem
            collapsed={false}
            title={'Data Vault Browser'}>
                <span style={{
                    ...Appearance.textStyles.defaultText(),
                    display: 'block',
                    marginBottom: 12
                }}>{`Browse your stored files and folders below to choose what you'd like to include. You can select individual files, or click on a folder to automatically select everything inside it. You can update your selection anytime before confirming.`}</span>
                <span style={{
                    ...Appearance.textStyles.defaultText(),
                    display: 'block'
                }}>
                    <span style={{
                        display: 'block',
                        marginBottom: 4 
                    }}>{`• Tip: Hold Command (⌘) on Mac or Control (Ctrl) on Windows to select multiple items.`}</span>
                    <span style={{
                        display: 'block'
                    }}>{`• Folder selections will include all files contained within that folder.`}</span>
                </span>
            </LayerItem>
            <DataVault
            onSelectionChange={setItems}
            ref={dataVaultRef}
            selections={items}
            utils={utils} />
        </Layer>
    )
}

export default DataVaultItemsPickerField;